var _style, _defs, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 609.45 793.7",
    style: {
      enableBackground: "new 0 0 609.45 793.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000147925441132384908490000004197376647394520714_);fill:url(#SVGID_00000036220698992024237170000003224335630422643102_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000155837620834418292680000007504782429262948240_);fill:url(#SVGID_00000049221977765450987160000016049561255725373113_);}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M54,373.34C54.59,475.09,156.14,534,226.33,525.23c59.7-7.46,85.17-50.01,84.63-50.53 c-107.8-105.3-18.8-266.99,95.28-266.99c114.06,0,154.77,93.51,154.77,93.51c-31.32-107.96-129.7-187.13-247.76-187.13 C170.08,114.08,53.16,230.18,54,373.34"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168816091613638819960000013010458188684377253_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000007427777745129146280000002609548577489207981_",
    cx: -84.6129,
    cy: 704.4511,
    r: 5.2731,
    gradientTransform: "matrix(43.8374 0 0 -43.8374 4016.2944 31201.2891)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E8BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1834,
    style: {
      stopColor: "#A8C098"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    style: {
      stopColor: "#527954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#003F1B"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.16,
    y: 114.08,
    style: {
      clipPath: "url(#SVGID_00000168816091613638819960000013010458188684377253_)",
      fill: "url(#SVGID_00000007427777745129146280000002609548577489207981_)"
    },
    width: 507.84,
    height: 419.92
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072256697317631280870000008913303685553500833_",
    d: "M397.45,219c-59.71,7.45-88.28,47.09-87.75,47.62 c106.55,105.3,21.32,270.77-92.76,270.77c-114.06,0-154.17-94.37-154.17-94.37c31.33,107.97,129.7,187.13,247.75,187.13 c143.17,0,260.09-116.1,259.25-259.27c-0.56-95.06-89.24-152.75-158.14-152.75C406.8,218.13,402.06,218.41,397.45,219"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138539055933404174370000014754014876231894178_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072256697317631280870000008913303685553500833_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000131351718721369571930000014608890863551761048_",
    cx: -84.4449,
    cy: 702.5123,
    r: 5.2637,
    gradientTransform: "matrix(43.8373 0 0 -43.8373 4018.5369 31220.3789)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#74CFEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1446,
    style: {
      stopColor: "#67B3D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4558,
    style: {
      stopColor: "#4A7EA2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9065,
    style: {
      stopColor: "#203E6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    style: {
      stopColor: "#1C3664"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C3664"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.78,
    y: 218.13,
    style: {
      clipPath: "url(#SVGID_00000138539055933404174370000014754014876231894178_)",
      fill: "url(#SVGID_00000131351718721369571930000014608890863551761048_)"
    },
    width: 507.84,
    height: 412.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7baf3ced42cd4b8985ba558074c0ea6e.svg";
export { ForwardRef as ReactComponent };